export default {
  PHOTO: "img",
  PDF: "pdf",
  EXCEL: "xls",
  WORD: "doc",
  VIDEO: "video",
}